import React from 'react';
import { IconChevronLeftSvg } from 'apps/sigma2-ui/src/components/svg/IconChevronLeft';
import { IconChevronRightSvg } from 'apps/sigma2-ui/src/components/svg/IconChevronRight';

export const PaginationButtons: React.FC<{
  totalPages: number;
  currentPage: number;
  onPreviousPageClick: () => void;
  onNextPageClick: () => void;
}> = (props) => {
  const onPreviousPageClick = () => {
    if (props.currentPage > 1) {
      props.onPreviousPageClick();
    }
  };

  const onNextPageClick = () => {
    if (props.currentPage < props.totalPages) {
      props.onNextPageClick();
    }
  };

  const hasNextPage = props.currentPage < props.totalPages;
  const hasPrevPage = props.currentPage > 1;

  if (props.totalPages === 1) {
    return null;
  }

  return (
    <div className="flex space-x-2 text-sm font-sans">
      <button onClick={onPreviousPageClick} aria-label="Previous page">
        <IconChevronLeftSvg
          svg={{ className: `h-5 ${hasPrevPage ? '' : 'opacity-50'}` }}
        />
      </button>

      <p>
        {props.currentPage} of {props.totalPages}
      </p>

      <button onClick={onNextPageClick} aria-label="Next page">
        <IconChevronRightSvg
          svg={{ className: `h-5 ${hasNextPage ? '' : 'opacity-50'}` }}
        />
      </button>
    </div>
  );
};
